import React, { useState, useEffect } from 'react'
import { Input, Modal, Form, Row, Col } from 'antd'

const emailValidator = /^$|(\S+)@(\S+){2,}\.(\S+){2,}/

const WSAccessEditPrompt = props => {
  const { mode = 'new', getSaveTask } = props

  const {
    getFieldDecorator,
    getFieldValue,
    validateFields,
    setFieldsValue,
  } = props.form

  const [serviceName, setServiceName] = useState(props.serviceName)
  // eslint-disable-next-line no-unused-vars
  const [endpointName, setEndpointName] = useState(
    props.endpointName || 'SANDBOX'
  )

  const [url, setUrl] = useState(props.url || '')
  const [userName, setUserName] = useState(props.userName || '')
  const [password, setPassword] = useState(props.password || '')
  // eslint-disable-next-line no-unused-vars
  const [confirmPassword, setConfirmPassword] = useState(props.password || '')
  const [certEmail, setCertEmail] = useState(props.certEmail || '')
  const [certPassword, setCertPassword] = useState(props.certPassword || '')
  const [certConfirmPassword, setCertConfirmPassword] = useState(
    props.certPassword || ''
  )
  // eslint-disable-next-line no-unused-vars
  const [apiUserId, setApiUserId] = useState(props.apiUserId || '')
  // eslint-disable-next-line no-unused-vars
  const [apiSigningKey, setApiSigningKey] = useState(props.apiSigningKey || '')

  const isReadyForSaving = () => {
    // const serviceNameValid = serviceName
    // const endpointNameValid = endpointName
    const certPasswordValid = certPassword === certConfirmPassword
    const certEmailValid = emailValidator.test(certEmail)

    // !serviceNameValid && validateFields(['serviceName'], { force: true })
    // !endpointNameValid && validateFields(['endpointName'], { force: true })
    !certPasswordValid &&
      validateFields(['certConfirmPassword'], { force: true })
    !certEmailValid && validateFields(['certEmail'], { force: true })
    return certPasswordValid && certEmailValid
  }

  const saveTask = () => {
    if (isReadyForSaving()) {
      getSaveTask({
        serviceName,
        endpointName,
        url,
        certPassword,
        certEmail,
        activeStatus: true,
        apiUserId,
        apiSigningKey,
        userName,
        password,
      })
    }
  }

  const compareToFirstCertPassword = (rule, value, callback) => {
    if (value !== getFieldValue('certPassword')) {
      // eslint-disable-next-line standard/no-callback-literal
      callback('Confirm password does not match')
    }
    callback()
  }
  const compareToFirstPassword = (rule, value, callback) => {
    if (value !== getFieldValue('password')) {
      // eslint-disable-next-line standard/no-callback-literal
      callback('Confirm password does not match')
    }
    callback()
  }

  const validateToNextCertPassword = (rule, value, callback) => {
    if (value) {
      validateFields(['certConfirmPassword'])
    }
    callback()
  }

  const validateToNextPassword = (rule, value, callback) => {
    if (value) {
      validateFields(['confirmPassword'])
    }
    callback()
  }

  const validateCertEmail = (rule, value, callback) => {
    if (!emailValidator.test(value)) {
      // eslint-disable-next-line standard/no-callback-literal
      callback('Please Enter Valid Email')
    } else {
      callback()
    }
  }

  useEffect(
    () => {
      setFieldsValue({
        serviceName,
        endpointName,
        certEmail,
        certPassword,
        certConfirmPassword,
        userName,
        password,
      })
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [endpointName, serviceName, setFieldsValue, userName]
  )

  return (
    <Modal
      width={800}
      maskClosable={false}
      visible
      title={mode === 'new' ? 'New Data' : 'Edit Data'}
      onCancel={() => props.close(null)}
      onOk={saveTask}
      okText={mode === 'new' ? 'Create Data' : 'Save'}
      cancelButtonProps={{
        style: { float: 'right', marginLeft: '10px', marginRight: '10px' },
      }}
    >
      <Form layout="vertical">
        <Row gutter={8}>
          <Col span={8}>
            <Form.Item label="Service Name" style={{ marginBottom: '5px' }}>
              {getFieldDecorator('serviceName', {
                rules: [
                  { required: true, message: 'Please enter Service Name' },
                ],
              })(
                <Input
                  placeholder="Service Name"
                  name="serviceName"
                  onChange={e => setServiceName(e.target.value)}
                  disabled={mode !== 'new'}
                />
              )}
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={8}>
          <Col span={8}>
            <Form.Item label="User Name" style={{ marginBottom: '5px' }}>
              {getFieldDecorator('userName', {
                rules: [{}],
              })(
                <Input
                  placeholder="User Name"
                  name="userName"
                  onChange={e => {
                    setUserName(e.target.value)
                    setFieldsValue({ userName: e.target.value })
                    // setServiceName(e.target.value)
                  }}
                />
              )}
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label="Password" style={{ marginBottom: '5px' }}>
              {getFieldDecorator('password', {
                rules: [
                  {
                    validator: validateToNextPassword,
                  },
                ],
              })(
                <Input.Password
                  placeholder="Password"
                  name="password"
                  onChange={e => {
                    setPassword(e.target.value)
                    setFieldsValue({ password: e.target.value })
                  }}
                />
              )}
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label="Confirm Password" style={{ marginBottom: '5px' }}>
              {getFieldDecorator('confirmPassword', {
                rules: [
                  {
                    validator: compareToFirstPassword,
                  },
                ],
              })(
                <Input.Password
                  placeholder="Confirm Password"
                  name="confirmPassword"
                  onChange={e => {
                    setConfirmPassword(e.target.value)
                    setFieldsValue({ confirmPassword: e.target.value })
                  }}
                />
              )}
            </Form.Item>
          </Col>
          {/* <Col span={8}>
            <Form.Item label="End Point" style={{ marginBottom: '5px' }}>
              {getFieldDecorator('endpointName', {
                rules: [{ required: true, message: 'Please select End Point' }],
              })(
                <Select
                  name="endpointName"
                  placeholder="End Point"
                  onChange={val => setEndpointName(val)}
                  disabled={mode !== 'new'}
                >
                  <Select.Option key="SANDBOX" value="SANDBOX">
                    SANDBOX
                  </Select.Option>
                  <Select.Option key="PRODUCTION" value="PRODUCTION">
                    PRODUCTION
                  </Select.Option>
                </Select>
              )}
            </Form.Item>
          </Col> */}
        </Row>

        <Row gutter={8}>
          <Col span={24}>
            <Form.Item label="URL" style={{ marginBottom: '5px' }}>
              <Input
                placeholder="URL"
                value={url || ''}
                name="url"
                onChange={e => setUrl(e.target.value)}
              />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={8}>
          <Col span={8}>
            <Form.Item label="Cert Email" style={{ marginBottom: '5px' }}>
              {getFieldDecorator('certEmail', {
                rules: [
                  {
                    validator: validateCertEmail,
                  },
                ],
              })(
                <Input
                  placeholder="Certificate Email"
                  name="certEmail"
                  onChange={e => {
                    setCertEmail(e.target.value)
                    setFieldsValue({ certEmail: e.target.value })
                  }}
                />
              )}
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label="Cert Password" style={{ marginBottom: '5px' }}>
              {getFieldDecorator('certPassword', {
                rules: [
                  {
                    validator: validateToNextCertPassword,
                  },
                ],
              })(
                <Input.Password
                  placeholder="Cert Password"
                  name="certPassword"
                  onChange={e => {
                    setCertPassword(e.target.value)
                    setFieldsValue({ certPassword: e.target.value })
                  }}
                />
              )}
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              label="Confirm Cert Password"
              style={{ marginBottom: '5px' }}
            >
              {getFieldDecorator('certConfirmPassword', {
                rules: [
                  {
                    validator: compareToFirstCertPassword,
                  },
                ],
              })(
                <Input.Password
                  placeholder="Confirm Cert Password"
                  name="certConfirmPassword"
                  onChange={e => {
                    setCertConfirmPassword(e.target.value)
                    setFieldsValue({ certConfirmPassword: e.target.value })
                  }}
                />
              )}
            </Form.Item>
          </Col>
        </Row>
        {/* <Row gutter={8}>
          <Col span={8}>
            <Form.Item label="Api User Id" style={{ marginBottom: '5px' }}>
              <Input
                placeholder="Api User Id"
                value={apiUserId || ''}
                name="apiUserId"
                onChange={e => setApiUserId(e.target.value)}
              />
            </Form.Item>
          </Col>
          <Col span={16}>
            <Form.Item label="Api Signing Key" style={{ marginBottom: '5px' }}>
              <Input
                placeholder="Api Signing Key"
                value={apiSigningKey || ''}
                name="apiSigningKey"
                onChange={e => setApiSigningKey(e.target.value)}
              />
            </Form.Item>
          </Col>
        </Row> */}
      </Form>
    </Modal>
  )
}

export default Form.create({ name: 'web_service_access' })(WSAccessEditPrompt)
